var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 29,
    viewBox: "0 0 43 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5727 1.43797C43.4976 3.33946 43.4712 6.40119 41.5197 8.27368L22.3594 26.6666C20.7651 28.2201 18.6583 29 16.5481 29C14.4379 29 12.3078 28.2136 10.6905 26.6409L1.50883 17.9713C-0.459134 16.1117 -0.508747 13.0532 1.39968 11.1356C3.31142 9.21799 6.44694 9.17287 8.41491 11.0292L16.5282 18.6932L34.5541 1.38962C36.5056 -0.48609 39.6543 -0.457085 41.5693 1.44119L41.5727 1.43797Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlack);
export default __webpack_public_path__ + "static/media/check-black.b2ed9a85d1cd5610b8f338d50f4790a4.svg";
export { ForwardRef as ReactComponent };